import { Col, PageWrapper, Row } from '@qonsoll/react-design'
import { HeaderBreadcrumbs, Spinner } from 'components'
import { useHistory, useParams } from 'react-router-dom'

import { CountryAdvancedForm } from 'domains/Country/components'
import { useGetCountryInitialValues } from 'domains/Country/hooks'
import { useTranslations } from 'contexts/Translation'

const CountryEdit = () => {
  /* Getting translations instance */
  const { t } = useTranslations()

  /* Getting history instance */
  const history = useHistory()

  /* Getting params from router */
  const params = useParams()

  /* Getting id from params */
  const { countryId } = params

  /* Fetching country initial values */
  const [initialValues, loading] = useGetCountryInitialValues(countryId)

  /* Configuring page header */
  const headingProps = {
    title: t('Country edit'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }

  /* Function to handle back click */
  const handleBack = () => history.goBack()

  return (
    <PageWrapper
      onBack={handleBack}
      breadcrumbs={<HeaderBreadcrumbs />}
      headingProps={headingProps}>
      <Row noGutters>
        {loading ? (
          <Col>
            <Spinner height="70vh" text={t('Country loading')} />
          </Col>
        ) : (
          <Col cw={[12, 12, 10, 8, 7]}>
            <CountryAdvancedForm initialData={initialValues} />
          </Col>
        )}
      </Row>
    </PageWrapper>
  )
}

export default CountryEdit
